import Version from './lib/Version';
import GA4Provider from '../analytics/providers/GA4Provider';
import AnalyticsService from '../analytics/AnalyticsService';
import Rum from '../observability/Rum';

/**
 * @param {IAnalyticsConfiguration} config
 */

function setupAnalytics(config) {
  const ga4 = new GA4Provider(config);

  ga4.init();

  AnalyticsService.registerProvider(ga4);
}

function setupRum(config) {
  if (config) {
    new Rum(config);
  }
}

class App {
  /**
   * @param {Object} config
   * @param {string} config.appVersion
   * @param {string} config.tessituraVersion
   * @param {string} config.environment
   * @param {string} config.rootUrl
   * @param {string} config.bcp47LanguageTag
   * @param {string} config.iso4217CurrencyCode
   * @param {IAnalyticsConfiguration} config.analyticsConfiguration
   * @param {RumSettings} config.rumSettings
   */
  init({
    appVersion,
    tessituraVersion,
    environment,
    rootUrl,
    bcp47LanguageTag,
    iso4217CurrencyCode,
    analyticsConfiguration,
    rumSettings,
  }) {
    this.appVersion = Version.fromString(appVersion);
    this.tessituraVersion = Version.fromString(tessituraVersion);
    this.environment = environment;
    this.rootUrl = rootUrl;
    this.bcp47LanguageTag = bcp47LanguageTag;
    this.iso4217CurrencyCode = iso4217CurrencyCode;

    setupAnalytics(analyticsConfiguration);

    setupRum(rumSettings);
  }

  getRootUrl() {
    return this.rootUrl;
  }
}

export default App;
